import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { toast } from 'react-toastify';
import { useKeycloak } from './KeycloakContext';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import Sidebar from './components/Sidebar';
import TimeSlotModal from './components/TimeSlotModal';
import LogModal from './components/LogModal';
import {getLaboratorioUtente, createEsperimento, updateEsperimento, updateLaboratorio, uploadFile} from './api/api.private.service';
import { getMediaLink } from './api/utils';

const LabManagementPage = () => {
  const [lab, setLab] = useState(null);
  const [editingLab, setEditingLab] = useState(null);
  const [editingExp, setEditingExp] = useState(null);
  const [selectedExperiment, setSelectedExperiment] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [timeSlots, setTimeSlots] = useState({});
  const [showTimeSlotModal, setShowTimeSlotModal] = useState(false);
  const [showLogModal, setShowLogModal] = useState(false);
  const [showEditLabModal, setShowEditLabModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [previewExperimentImage, setPreviewExperimentImage] = useState(null);

  const fetchLaboratorioUtente = async () => {
    const data = await getLaboratorioUtente();
    setLab(data.data[0]);
    setEditingLab({...data.data[0]}); // TODO: impostare API backend
  }

  useEffect(() => {
    
    fetchLaboratorioUtente();
  }, []);

  const saveImage = async (entity) => {
    const formData = new FormData();
    formData.append('files', editingLab.immagine);
    formData.append('refId', lab.id);
    formData.append('ref', 'api::laboratori.laboratori');
    formData.append('field', 'immagine');
    const uploaded = await uploadFile(formData);
  }

  const handleExperimentImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditingExp({ ...editingExp, immagine: file });
      setPreviewExperimentImage(URL.createObjectURL(file));
    }
  };

  const handleCloseEditLabModal = () => {
    setEditingLab({ ...lab });
    setPreviewImage(null);
    setShowEditLabModal(false);
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditingLab({ ...editingLab, immagine: file });
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleExperimentClick = (experiment) => {
    setSelectedExperiment(experiment);
    setEditingExp(experiment);
    setPreviewExperimentImage(null);
  };

  const handleExperimentSave = async () => {
    setIsSaving(true);
    try {
      
      if(selectedExperiment) {
        await updateExperiment();
      } else {
        await createExperiment();
      }
      fetchLaboratorioUtente();
      toast.success(`Esperimento ${selectedExperiment ? 'modificato' : 'creato'} con successo!`);
    } catch (e) {
      console.error(`Errore nella ${selectedExperiment ? 'modifica' : 'creazione'} dell\'esperimento:`, e);
      toast.error(`Errore nella ${selectedExperiment ? 'modifica' : 'creazione'} dell\'esperimento:`);
    } finally {
      setIsSaving(false);
    }
  };

  const updateExperiment = async () => {
    await updateEsperimento(editingExp.documentId, {
      titolo: editingExp.titolo,
      descrizione: editingExp.descrizione,
    });

    if (previewExperimentImage) {
      const formData = new FormData();
      formData.append('files', editingExp.immagine);
      formData.append('refId', editingExp.id);
      formData.append('ref', 'api::esperimenti.esperimenti');
      formData.append('field', 'immagine');
      await uploadFile(formData);
    }
  }

  const createExperiment = async () => {
    const data = await createEsperimento({
      titolo: editingExp.titolo,
      descrizione: editingExp.descrizione,
    });

    console.log(data)

    await updateLaboratorio(lab.documentId, {
      esperimentis: {
        connect: [data.documentId]
      }
    });

    // if (previewExperimentImage) {
    //   const formData = new FormData();
    //   formData.append('files', editingExp.immagine);
    //   formData.append('refId', editingExp.id);
    //   formData.append('ref', 'api::esperimenti.esperimenti');
    //   formData.append('field', 'immagine');
    //   await uploadFile(formData);
    // }
  }

  const handleExperimentDelete = (experimentToDelete) => {
    const updatedExperiments = lab.experiments.filter(exp => exp.name !== experimentToDelete.name);
    setLab({ ...lab, experiments: updatedExperiments });
    setSelectedExperiment(null);
  };

  const handleAddExperiment = () => {
    const newExperiment = { titolo: '', descrizione: '' };
    setSelectedExperiment(null);
    setEditingExp(newExperiment);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleAddTimeSlot = (timeSlot) => {
    const dateKey = selectedDate.toISOString().split('T')[0];
    const updatedTimeSlots = { ...timeSlots };
    if (!updatedTimeSlots[dateKey]) {
      updatedTimeSlots[dateKey] = [];
    }
    updatedTimeSlots[dateKey].push(timeSlot);
    setTimeSlots(updatedTimeSlots);
    setShowTimeSlotModal(false);
  };

  const handleDeleteTimeSlot = (dateKey, index) => {
    const updatedTimeSlots = { ...timeSlots };
    updatedTimeSlots[dateKey].splice(index, 1);
    if (updatedTimeSlots[dateKey].length === 0) {
      delete updatedTimeSlots[dateKey];
    }
    setTimeSlots(updatedTimeSlots);
  };

  const handleSaveLogs = () => {
    fetch('/api/save-logs', {
      method: 'POST',
      body: JSON.stringify(timeSlots),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      toast.success('Modifiche salvate con successo!');
      setShowLogModal(false);
    })
    .catch(error => {
      console.error('Errore nel salvataggio delle modifiche:', error);
      toast.error('Errore nel salvataggio delle modifiche.');
    });
  };

  const handleEditLab = () => {
    setShowEditLabModal(true);
  };

  const handleEditLabSave = async () => {
    setIsSaving(true);
    try {
      const data = await updateLaboratorio(lab.documentId, {
        nome: editingLab.nome,
        descrizione: editingLab.descrizione,
      });
      if(previewImage) {
        try {
          await saveImage(editingLab);
        } catch (e) {
          console.error('Errore nel caricamento del file.', e);
          toast.error('Errore nel caricamento del file.');
        }
      }
      fetchLaboratorioUtente();
      toast.success('Laboratorio modificato con successo!');
      setShowEditLabModal(false);
    } catch (e) {
      console.error('Errore nella modifica del laboratorio:', e);
      toast.error('Errore nella modifica del laboratorio.');
    } finally {
      setIsSaving(false);
    }
  };

  const dateKey = selectedDate.toISOString().split('T')[0];
  const selectedDateSlots = timeSlots[dateKey] || [];
  const formattedDate = format(selectedDate, 'dd MMMM yyyy', { locale: it });

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(rgba(255,255,255,.9), rgba(255,255,255,.9)), url("/bg.png")', backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
      <Navbar />
      <div className="flex flex-col items-center p-5">
        <div>
          <h1 className="text-4xl font-bold text-gray-800 inline-block">
            {lab ? `Gestione: ${lab.nome}` : 'Crea un nuovo laboratorio'}
          </h1>
          {lab && (
            <button onClick={handleEditLab} className="ml-2 text-gray-600 hover:text-gray-800">
              <i className="fas fa-pencil-alt"></i>
            </button>
          )}
        </div>
        {lab && <p className="text-gray-600 mt-2">{lab.descrizione}</p>}
        {lab && <img
                src={getMediaLink(editingLab.immagine?.url)}
                width={'300px'}
                alt={editingLab.nome}
              />
        }
      </div>
      <div className="flex flex-col lg:flex-row flex-1 py-10 px-6">
        {lab && (
          <Sidebar
            experiments={lab.esperimentis}
            onExperimentClick={handleExperimentClick}
            onAddExperiment={handleAddExperiment}
            selectedExperiment={selectedExperiment}
          />
        )}

        {selectedExperiment || editingExp ? (
          <div className="w-full lg:w-2/3 p-5 flex flex-col items-center bg-white p-4 rounded-lg shadow-md lg:ml-5">
          <h2 className="text-2xl font-bold text-gray-800 mt-6 mb-6">
            {selectedExperiment ? `Modifica Esperimento` : 'Aggiungi Esperimento'}
          </h2>
        
          <div className="flex w-full">
            <div className="flex flex-col w-1/2 items-center px-20">
              <label className="block mb-2 text-lg font-semibold">Titolo</label>
              <input
                type="text"
                value={editingExp.titolo}
                onChange={(e) =>
                  setEditingExp({
                    ...editingExp,
                    titolo: e.target.value,
                  })
                }
                className="w-full border p-2 rounded mb-4"
                disabled={isSaving}
              />
              <label className="block mb-2 text-lg font-semibold">Descrizione</label>
              <textarea
                value={editingExp.descrizione}
                onChange={(e) =>
                  setEditingExp({
                    ...editingExp,
                    descrizione: e.target.value,
                  })
                }
                className="w-full border p-2 rounded mb-4"
                rows={5}
                disabled={isSaving}
              ></textarea>
            </div>
            <div className="flex flex-col w-1/2 items-center px-20">
              <label className="block mb-2 text-lg font-semibold">Immagine</label>
              <input
                type="file"
                onChange={handleExperimentImageChange}
                className="w-full border p-2 rounded mb-4"
                disabled={isSaving}
              />
              {previewExperimentImage ? (
                <img
                  src={previewExperimentImage}
                  alt="Anteprima Immagine Esperimento"
                  className="mt-4 rounded-lg shadow-md"
                  width="200"
                />
              ) : (
                editingExp.immagine?.url && (
                  <img
                    src={getMediaLink(editingExp.immagine?.url)}
                    alt={editingExp.titolo}
                    className="mt-4 rounded-lg shadow-md"
                    width="200"
                  />
                )
              )}
            </div>
          </div>
        
          <button
            onClick={() => handleExperimentSave()}
            className={`block text-base h-12 font-semibold bg-[#3e96ac] text-white px-3 py-1 rounded-lg shadow-md hover:bg-[#e06615] lg:px-6 lg:py-3 mt-[1rem] flex items-center ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={isSaving}
          >
            {isSaving ? (
              <span className="flex items-center">
                <i className="fas fa-spinner fa-spin mr-2"></i> Salvataggio...
              </span>
            ) : (
              <>
                <i className="fas fa-save mr-3"></i>Salva Esperimento
              </>
            )}
          </button>

          <div className="flex flex-col w-1/2 items-center">
              {/* Time slots for the selected experiment */}
              <h2 className="text-2xl font-bold text-gray-800 mt-20 mb-6">
                Gestisci Time Slots
              </h2>
              <Calendar onChange={handleDateChange} value={selectedDate} />
              <button
                onClick={() => setShowTimeSlotModal(true)}
                className="mt-4 block text-center bg-[#3e96ac] text-white px-4 py-2 rounded-lg shadow-md hover:bg-[#e06615]"
              >
                <i className="fas fa-plus mr-2"></i> Aggiungi Time Slot
              </button>
              <div className="mt-6 w-full">
                <h3 className="text-xl font-bold text-gray-800 mb-4">
                  Time Slots per {formattedDate}
                </h3>
                <ul>
                  {selectedDateSlots &&
                    selectedDateSlots.map((slot, index) => (
                      <li
                        key={index}
                        className="mb-2 p-4 rounded-xl border border-gray-200 flex justify-between items-center"
                      >
                        <span className="bg-black text-white rounded-xl px-5">
                          {slot.startTime} - {slot.endTime}
                        </span>
                        <button
                          onClick={() => handleDeleteTimeSlot(dateKey, index)}
                          className="px-2 py-1 rounded-lg hover:text-[#e06615]"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
        </div>
        ) : (
          <div className="w-full lg:w-2/3 p-5 flex flex-col items-center bg-white p-4 rounded-lg shadow-md lg:ml-5">
            <h2 className="text-2xl font-bold text-gray-800 mt-6 mb-6">
              Seleziona un esperimento per modificarlo
            </h2>
          </div>
        )}
      </div>
      <Footer />
      {showTimeSlotModal && (
        <TimeSlotModal 
          onClose={() => setShowTimeSlotModal(false)} 
          onSave={handleAddTimeSlot} 
        />
      )}
      {showLogModal && (
        <LogModal 
          logs={timeSlots} 
          onClose={() => setShowLogModal(false)} 
          onSave={handleSaveLogs} 
        />
      )}
      {showEditLabModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h2 className="text-2xl font-bold mb-4">Modifica Laboratorio</h2>
            <label className="block mb-2 text-lg font-semibold">Nome</label>
            <input
              type="text"
              value={editingLab.nome}
              onChange={(e) => setEditingLab({ ...editingLab, nome: e.target.value })}
              className="w-full border p-2 rounded mb-4"
              disabled={isSaving} // Disabilita durante il caricamento
            />
            <label className="block mb-2 text-lg font-semibold">Descrizione</label>
            <textarea
              value={editingLab.descrizione}
              onChange={(e) => setEditingLab({ ...editingLab, descrizione: e.target.value })}
              className="w-full border p-2 rounded mb-4"
              disabled={isSaving} // Disabilita durante il caricamento
            ></textarea>
            <label className="block mb-2 text-lg font-semibold">Logo</label>
            <input
              type="file"
              onChange={handleLogoChange}
              className="w-full border p-2 rounded mb-4"
              disabled={isSaving} // Disabilita durante il caricamento
            />
            {previewImage ? (
              <img
                src={previewImage}
                alt="Anteprima Logo"
                className="mt-4 rounded-lg shadow-md"
                width="200"
              />
            ) : (
              <img
                src={getMediaLink(editingLab.immagine?.url)}
                width={'200px'}
                alt={editingLab.nome}
              />
            )}
            
            <div className="flex justify-end">
              <button onClick={handleCloseEditLabModal}
                className={`bg-gray-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-[#e06615] ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={isSaving}
              >
                Annulla
              </button>
              <button
                onClick={handleEditLabSave}
                className={`bg-[#3e96ac] text-white px-4 py-2 rounded-lg shadow-md hover:bg-[#e06615] ml-4 ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={isSaving}
              >
                {isSaving ? (
                  <span className="flex items-center">
                    <i className="fas fa-spinner fa-spin mr-2"></i> Salvataggio...
                  </span>
                ) : (
                  'Salva'
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LabManagementPage;